import ArrowRightIconPath from "@ingka/ssr-icon/paths/arrow-right";

export default ArrowRightIconPath;
